module.exports = __webpack_public_path__ + "img/Billionaire-3.75a0a6e8.png";